import { Box, CenteringDiv, FlexRowDiv } from 'components/generic/HomePageComponents'
import { PWithStylizedSpan } from './Styled'

const SafeCommunity = ({ statementHeader }) => (
  <FlexRowDiv>
    <CenteringDiv smallMargins width='100%'>
      <Box
        width='100%'
        display={['inline', 'inline', 'flex']}
        flexDirection='row'
        justifyContent='center'
      >
        <PWithStylizedSpan
          fontSize={['18px', '18px', '20px', '24px']}
          maxWidth='100%'
          p='15px 0 0'
          textAlign='center'
          dangerouslySetInnerHTML={{ __html: statementHeader }}
        />
      </Box>
    </CenteringDiv>
  </FlexRowDiv>
)

export default SafeCommunity
